import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

let FinePortionSievingMassesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isWashed = useSelector(pipe(createWorksheetSelector!('Washing.IsWashed'), valueOrDefault(false)));

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      <Field input={<TextOutput />} name="Masses.DryMass" label="Sieve Portion Material Dry Mass" />
      {isWashed && (
        <Field input={<TextOutput />} name="Washing.WashedDryMass" label="Sieve Portion Washed Material Dry Mass" />
      )}
      <Field input={<TextOutput />} name="Masses.MassUpscaleFactor" />
    </ListFieldSection>
  );
};
FinePortionSievingMassesSection = withInjectedProps(FinePortionSievingMassesSection);

export { FinePortionSievingMassesSection };
export default FinePortionSievingMassesSection;
